import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSubscriptionQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null, readonly isTrial: boolean, readonly endDate?: string | null } } | null };

export type GetTariffNameQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTariffNameQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly subscription: { readonly __typename?: 'YalperSubscription', readonly tariffDetails?: { readonly __typename?: 'BillingTariff', readonly name: string } | null } } | null };


export const GetSubscriptionDocument = gql`
    query GetSubscription {
  currentUser {
    subscription {
      planId
      isTrial
      endDate
    }
  }
}
    `;

/**
 * __useGetSubscription__
 *
 * To run a query within a React component, call `useGetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscription(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionHookResult = ReturnType<typeof useGetSubscription>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSuspenseQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>;
export const GetTariffNameDocument = gql`
    query GetTariffName {
  currentUser {
    subscription {
      tariffDetails {
        name
      }
    }
  }
}
    `;

/**
 * __useGetTariffNameQuery__
 *
 * To run a query within a React component, call `useGetTariffNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTariffNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTariffNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTariffNameQuery(baseOptions?: Apollo.QueryHookOptions<GetTariffNameQueryPage, GetTariffNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTariffNameQueryPage, GetTariffNameQueryVariables>(GetTariffNameDocument, options);
      }
export function useGetTariffNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTariffNameQueryPage, GetTariffNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTariffNameQueryPage, GetTariffNameQueryVariables>(GetTariffNameDocument, options);
        }
export function useGetTariffNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTariffNameQueryPage, GetTariffNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTariffNameQueryPage, GetTariffNameQueryVariables>(GetTariffNameDocument, options);
        }
export type GetTariffNameQueryHookResult = ReturnType<typeof useGetTariffNameQuery>;
export type GetTariffNameLazyQueryHookResult = ReturnType<typeof useGetTariffNameLazyQuery>;
export type GetTariffNameSuspenseQueryHookResult = ReturnType<typeof useGetTariffNameSuspenseQuery>;
export type GetTariffNameQueryResult = Apollo.QueryResult<GetTariffNameQueryPage, GetTariffNameQueryVariables>;